import * as Yup from 'yup';

export const PrescriptionSchema = Yup.object().shape({
  medicines: Yup.array()
    .of(
      Yup.object().shape({
        description: Yup.string()
          .max(500, ({ max }) => `The maximum is ${max} characters`)
          .required('This field is required'),
        quantity: Yup.number()
          .typeError('Must be a number')
          // .min(1, 'Must be greater or equal to 1')
          .required('This field is required'),
        unitPrice: Yup.number().typeError('Must be a number').required('This field is required'),
      }),
    )
    .required('This field is required'),
  note: Yup.string().max(500, ({ max }) => `The maximum is ${max} characters`),
});

export const PrescriptionMaNaPharmaSchema = Yup.object().shape({
  medicines: Yup.array()
    .of(
      Yup.object().shape({
        description: Yup.object().shape({
          Dosage: Yup.string(),
          id: Yup.string(),
          name: Yup.string(),
          unitPrice: Yup.number(),
          uom: Yup.string(),
          vendor: Yup.string(),
        }),
        // timeUnit: Yup.string()
        //   .required('This field is required'),
        // frequencyCode: Yup.string().required('This field is required'),
        // amountPerTime: Yup.number()
        //   .required('This field is required')
        //   .min(0.00001, 'Dosage must be greater than or equal to 0'),
      }),
    )
    .required('This field is required'),
  note: Yup.string().max(500, ({ max }) => `The maximum is ${max} characters`),
});
